import { useEffect, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { toggleAdminView } from '../store/slices/authSlice';

/**
 * Custom hook that provides information about the user's admin status
 * @returns {Object} Object containing admin status information
 */
const useAdmin = () => {
  const { 
    isAuthenticated, 
    user, 
    userType, 
    isAdmin: reduxIsAdmin, 
    adminViewActive,
    loading 
  } = useSelector(state => state.auth);
  const dispatch = useDispatch();
  const [isAdmin, setIsAdmin] = useState(false);
  const [isReady, setIsReady] = useState(false);
  
  useEffect(() => {
    // Only set admin status when auth is no longer loading
    if (!loading) {
      // Use the isAdmin state directly from Redux
      setIsAdmin(reduxIsAdmin);
      setIsReady(true);
      
      // Log admin status for debugging
      console.log('Admin status determined:', { 
        isAuthenticated, 
        userType, 
        reduxIsAdmin,
        adminViewActive,
        localIsAdmin: isAdmin,
        userEmail: user?.email
      });
    }
  }, [isAuthenticated, userType, loading, user, reduxIsAdmin, isAdmin, adminViewActive]);
  
  // Handle switching between admin and user view
  const toggleAdminViewMode = () => {
    dispatch(toggleAdminView());
  };
  
  return {
    isAdmin: reduxIsAdmin, // Return directly from Redux for immediate updates
    isLocalAdmin: isAdmin, // Local state version (if needed)
    isReady,
    isAuthenticated,
    userType,
    user,
    loading,
    adminViewActive,
    toggleAdminViewMode
  };
};

export default useAdmin; 